// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__hVZU5","label":"Radio_label__PMeEH","checkMark":"Radio_checkMark__N6Ojd","disabled":"Radio_disabled__lfxwd"};